import request from '#/utils/request';
import { keysToSnake } from '#/api/adapters/wireCase';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

/**
 * POST `/mom/work-order/{workOrderId}/stock-issue/{stockIssueId}/reject`
 * body：`rejectReason`、`updatedAt`（依契約）。
 *
 * @param {string} workOrderId
 * @param {string} stockIssueId
 * @param {object} payload
 */
export async function rejectWorkOrderStockIssue(
  workOrderId,
  stockIssueId,
  payload,
) {
  const { data: raw } = await request.post(
    `/mom/work-order/${workOrderId}/stock-issue/${stockIssueId}/reject`,
    keysToSnake(payload),
  );
  return parseVer4DetailResponse(raw);
}
